export interface ContractOption {
  id: string;
  title: string;
  description: string;
}

export enum ContractOptionId {
  CONTRACT = 'contract',
  ENDORSEMENT = 'endorsement',
  RENEWAL = 'renewal',
}
